import 'MaskedInput';

class Inputs {
    constructor() {
        this.init();

        window.addEventListener(
            'resize',
            () => {
                return this.refresh();
            },
            false
        );
        document.addEventListener(
            'inputs.reset',
            () => {
                return this.refresh();
            },
            false
        );
        document.addEventListener(
            'tabs.toggle',
            () => {
                return this.refresh();
            },
            false
        );
        document.addEventListener(
            'modal.open',
            () => {
                return this.refresh();
            },
            false
        );
        document.addEventListener(
            'input',
            (e) => {
                return this.changeFiled(e);
            },
            false
        );
        document.addEventListener(
            'paste',
            (e) => {
                return this.changeFiled(e);
            },
            false
        );
        document.addEventListener(
            'drop',
            (e) => {
                return this.changeFiled(e);
            },
            false
        );
        document.addEventListener(
            'cut',
            (e) => {
                return this.changeFiled(e);
            },
            false
        );
        document.addEventListener(
            'change',
            (e) => {
                return this.switchField(e);
            },
            false
        );
    }

    checkDirty(element) {
        return !element.value
            ? element.setAttribute('data-dirty', 'false')
            : element.setAttribute('data-dirty', true);
    }

    changeFiled(e) {
        let target = e.target || e;
        if (target.classList.contains('sst-field__input')) {
            if (target.tagName == 'INPUT' || target.tagName == 'TEXTAREA') {
                this.checkDirty(target);
                target.classList.remove('sst-field--has-error');
                if (target.classList.contains('sst-autoheight')) {
                    this.calcAutoheight(target);
                }
            }
        }
    }

    calcAutoheight(target) {
        target.style.height = target.style.minHeight = 'auto';
        target.style.height = target.style.minHeight =
            target.scrollHeight + 'px';
    }

    switchField(e) {
        let target = e.target;
        let input = target.parentNode.querySelector('.sst-field__input');
        if (input && input.type == 'checkbox') {
            input.classList.remove('sst-field--has-error');
        } else if (input && input.type == 'radio') {
            let name = input.parentNode.querySelector('.sst-field__input').name;
            let otherRadio = document.querySelectorAll(`[name= ${name}]`);
            input.classList.remove('sst-field--has-error');
            [].forEach.call(otherRadio, (item) => {
                item.classList.remove('sst-field--has-error');
            });
        }
    }

    checkAllInputs() {
        let inputs = document.querySelectorAll(
            'input.sst-field__input, textarea.sst-field__input'
        );
        [].forEach.call(inputs, (item) => {
            if (item.tagName == 'TEXTAREA') {
                if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
                    item.style.textIndent = '-3px';
                }
                if (item.classList.contains('sst-autoheight')) {
                    this.calcAutoheight(item);
                }
            } else {
                this.checkDirty(item);
            }
        });
    }

    setMask() {
        $('input[type = tel]')
            .mask('+7 (999) 999-99-99?9', {
                placeholder: '_',
                completed: function () {
                    $(this).removeClass('sst-field--has-error');
                },
            })
            .on('blur.mask', (e) => {
                this.checkDirty(e.currentTarget);
            });
    }

    unsetMask() {
        $('input[type = tel]').unmask();
    }

    init() {
        this.checkAllInputs();
        this.setMask();
    }

    refresh() {
        this.unsetMask();
        this.init();
    }
}

export default new Inputs();
